/**
 * The words a row shows for a lead's name — DECISION-155.
 *
 * Two different absences, told apart by the response rather than guessed:
 * `lib/serialize.ts` in the API DELETES a name the viewer may not read, so the
 * key is missing and the row says "Redacted"; a name the respondent never gave
 * is `null`, and the row says "Lead", as the drawer's own header does. Both read
 * "Redacted" until 2026-09-18, which reported every uncaptured name as withheld
 * — and until DECISION-155 no production lead had a name to capture (Q-114).
 */
export function leadName(name: string | null | undefined): string {
  if (name === undefined) return 'Redacted'
  return name?.trim() || 'Lead'
}
